import { render, staticRenderFns } from "./StocktakingRecord.vue?vue&type=template&id=0fdd5ed0&scoped=true&"
import script from "./StocktakingRecord.vue?vue&type=script&lang=js&"
export * from "./StocktakingRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdd5ed0",
  null
  
)

export default component.exports